"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Style = exports.CounterPluralize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var disabledBorderColor = '#919499';

var CounterPluralize = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var value = _ref.value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? Function.prototype : _ref$onChange,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 25 : _ref$maxValue,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 25 : _ref$size,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$zeroValueText = _ref.zeroValueText,
      zeroValueText = _ref$zeroValueText === void 0 ? '' : _ref$zeroValueText,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["value", "onChange", "step", "minValue", "maxValue", "size", "text", "zeroValueText", "className"]);
  var resultValue = value < 0 ? 0 : Number(value);
  var resultMinus = resultValue - step;
  var resultPlus = resultValue + step;
  var isMinusDisabled = resultMinus < minValue;
  var isPlusDisabled = resultPlus > maxValue;
  var counterText = zeroValueText.length ? zeroValueText : "".concat(resultValue, " ").concat(text);
  return /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, (0, _extends2["default"])({
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    size: size,
    disabled: isMinusDisabled,
    onClick: function onClick() {
      return onChange(resultMinus);
    },
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(IconMinus, null)), /*#__PURE__*/_react["default"].createElement(StyledCounter, {
    size: size
  }, counterText), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    size: size,
    disabled: isPlusDisabled,
    onClick: function onClick() {
      return onChange(resultPlus);
    },
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(IconPlus, null)));
});

exports.CounterPluralize = CounterPluralize;
CounterPluralize.displayName = 'CounterPluralize';

var StyledCounterPluralize = _styledComponents["default"].div.withConfig({
  displayName: "CounterPluralize__StyledCounterPluralize",
  componentId: "sc-do6kal-0"
})(["border-radius:", ";display:flex;"], function (props) {
  return props.theme.shape.borderRadius;
});

var StyledCounter = _styledComponents["default"].div.withConfig({
  displayName: "CounterPluralize__StyledCounter",
  componentId: "sc-do6kal-1"
})(["line-height:", "px;height:", "px;width:", "px;user-select:none;color:#000;font-size:14px;flex-grow:1;text-align:center;text-overflow:ellipsis;white-space:pre;overflow:hidden;"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

var Icon = _styledComponents["default"].i.withConfig({
  displayName: "CounterPluralize__Icon",
  componentId: "sc-do6kal-2"
})(["width:13px;position:relative;::before,::after{display:block;transition:120ms background ease-in;}"]);

var IconPlus = (0, _styledComponents["default"])(Icon).withConfig({
  displayName: "CounterPluralize__IconPlus",
  componentId: "sc-do6kal-3"
})(["::before,::after{box-sizing:border-box;content:'';width:100%;height:1px;background-color:", ";}::after{transform:rotate(90deg);top:0;position:absolute;}"], function (props) {
  return props.theme.colors.blue;
});
var IconMinus = (0, _styledComponents["default"])(Icon).withConfig({
  displayName: "CounterPluralize__IconMinus",
  componentId: "sc-do6kal-4"
})(["::before{box-sizing:border-box;content:'';width:100%;height:1px;background-color:", ";}"], function (props) {
  return props.theme.colors.blue;
});

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "CounterPluralize__StyledButton",
  componentId: "sc-do6kal-5"
})(["box-sizing:border-box;width:", "px;min-width:", "px;max-width:", "px;height:", "px;min-height:", "px;max-height:", "px;user-select:none;border:1px solid ", ";cursor:pointer;background:none;border-radius:100%;display:flex;align-items:center;justify-content:center;outline:none;:hover:enabled{border-color:", ";", "{::before,::after{background-color:", ";}}}:disabled{cursor:default;border-color:", ";", "{::before,::after{background-color:", ";}}}"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.theme.colors.blue;
}, function (props) {
  return props.theme.colors.brightBlue;
}, Icon, function (props) {
  return props.theme.colors.brightBlue;
}, disabledBorderColor, Icon, disabledBorderColor);

var Style = {
  StyledButton: StyledButton,
  StyledCounter: StyledCounter,
  IconMinus: IconMinus,
  IconPlus: IconPlus
};
exports.Style = Style;